module.exports = __webpack_public_path__ + "static/img/fraud.2f68a14b.png";